import _assert_this_initialized from "@swc/helpers/src/_assert_this_initialized.mjs";
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { BoundFormat, toFormat } from "./BoundFormat.js";
export var ABFormat = /*#__PURE__*/ function(BoundFormat) {
    "use strict";
    _inherits(ABFormat, BoundFormat);
    var _super = _create_super(ABFormat);
    function ABFormat(selectA, a, b) {
        _class_call_check(this, ABFormat);
        var _this;
        _this = _super.call(this, function(value) {
            return _this.selectA(value) ? _this.a.format(value) : _this.b.format(value);
        });
        Object.defineProperties(_assert_this_initialized(_this), {
            selectA: {
                value: selectA
            },
            a: {
                value: toFormat(a)
            },
            b: {
                value: toFormat(b)
            }
        });
        return _this;
    }
    return ABFormat;
}(BoundFormat);
export var ABFormatWithOptions = /*#__PURE__*/ function(ABFormat) {
    "use strict";
    _inherits(ABFormatWithOptions, ABFormat);
    var _super = _create_super(ABFormatWithOptions);
    function ABFormatWithOptions() {
        _class_call_check(this, ABFormatWithOptions);
        return _super.apply(this, arguments);
    }
    var _proto = ABFormatWithOptions.prototype;
    _proto.resolvedOptions = function resolvedOptions() {
        var _b, ref, _a, ref1;
        // Note:
        //  - support either formatter not actually having resolvedOptions
        //  - ensure the resolved options of a take precedence over those of b.
        return _object_spread({}, (ref = (_b = this.b).resolvedOptions) === null || ref === void 0 ? void 0 : ref.call(_b), (ref1 = (_a = this.a).resolvedOptions) === null || ref1 === void 0 ? void 0 : ref1.call(_a));
    };
    return ABFormatWithOptions;
}(ABFormat);
export var ABFormatToParts = /*#__PURE__*/ function(ABFormatWithOptions) {
    "use strict";
    _inherits(ABFormatToParts, ABFormatWithOptions);
    var _super = _create_super(ABFormatToParts);
    function ABFormatToParts() {
        _class_call_check(this, ABFormatToParts);
        return _super.apply(this, arguments);
    }
    var _proto = ABFormatToParts.prototype;
    _proto.formatToParts = function formatToParts(value) {
        return this.selectA(value) ? this.a.formatToParts(value) : this.b.formatToParts(value);
    };
    return ABFormatToParts;
}(ABFormatWithOptions);

//# sourceMappingURL=ABFormat.js.map